import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import layer from "./group/layer";
import top from "./group/top";
import imglist from "./group/imglist";
import contentmenu from "./group/contentmenu";
import codeedit from "./group/code";
import { dicOption } from '@/option/config';
import init from '@/mixins/';
import { uuid } from '@/util/utils';
import components from '@/option/components';
import SketchRule from "vue-sketch-ruler";
export default {
  mixins: [init, components],
  data: function data() {
    return {
      keys: {
        ctrl: false
      },
      loading: '',
      childProps: {
        label: 'name',
        value: 'index'
      },
      key: '',
      menuFlag: true,
      code: {
        box: false,
        type: '',
        obj: ''
      },
      form: {},
      dicOption: dicOption,
      tabsActive: 0,
      // 标尺
      scale: 0.9,
      //初始化标尺的缩放
      startX: 0,
      //x轴标尺开始的坐标数值
      startY: 0,
      lines: {
        //初始化水平标尺上的参考线
        h: [],
        v: []
      },
      rendIndex: 0,
      //重新渲染组件
      shadow: {
        x: 0,
        y: 0
      },
      // 阴影大小
      thick: 20,
      //标尺的厚度
      width: 0,
      // 标尺宽,后面会初始化
      height: 0,
      // 标尺高,后面会初始化
      wrapperHight: '',
      // 标尺外部style
      isShowReferLine: true,
      // 显示参考线
      isImgOpen: true,
      //眼镜打开
      imgOpenData: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAYAAAAOEM1uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAQNSURBVHja7JdvSON1HMdfP126/shSmaZ1ntuZbTLihOnSdJlPhIquB0VR1DZM9En0wCB3qCXKVOh86mmakdGDOqyHityBidYN1HPYZqbhOZprMGTOUk/9/XryWyxvek5NIu4Lg/H+fPj8Xt/P98/n8xUkSeK/PIT7gP8GoCAI8cTQAoWAHkgFRCAA3AKmgeBRA8VkOSZgMvAy8DZQCqQf4OcFRoDPgYmzAnwdaAAuxpFlCbgGfAR4ThUwYhcE4QngExnw71FWVuax2WwBk8mkSE9PV+7t7Ymrq6vbw8PD0uDgYO7CwsK5KPc14ENJkj497FtxAwqCYAK+kvcbANXV1U6Hw6HIyMh4GlAckJHwzMzMrM1my3a5XNoo01XgPUmSdk8MCLwEfAmoAPLz872jo6OrOTk5xVGBQ0tLS575+fnt7OzsRIPBcD4pKelctL2/v3+mtrbWLIpigixfA94BNk8C+JoMlyRn7WZvb68mISEhI+IQCASmKyoq0jweT25EU6lU4aGhoZnKykpzdNzl5eWbRqPxyWAwmCZL3wJvAHeOA/iCPMsHARwOx7jdbi+JXs7t7e3lrKys1LW1NVWsJXa73ZN6vb40WltfX3cbDIZ0r9ebKUv9wLvxAhYC1+V7je7u7rG6urrn9vu1tbWNNzU1lR90KgsLC5emp6cfB5TRejgc9mg0msyoTNYDXfEAjgFmQGxpaZlobm6OBbFrMpl+dTqd+YdcLztbW1ve5ORk7X6D3++f0ul0+aFQKAXYAF6RJOn6UQGDQBrgE0VRJQjCw7EAjUbj8tTUVN4hgLubm5u3lUrlhVjG+vr6ya6ursgWaJck6fJRAW8AzwNia2vrRGNjY8xltNvtEx0dHc8eRKfX62+73W418NB+m8/nm9LpdE+Fw+FHgD+AS/Fk8CJwI7IHe3t7x2pqau7agxsbG/NqtTp3a2tLGQtwcnJyvKSk5K7JhcPhnzQaTXYwGEyVpQ+AK8c5xd9EZt/e3v59Q0ND6f5LeXFx8cfy8vILfr9fHdEUCsVOX1/fhMViqdgfOxQKzRUUFKh9Pt+JTnHk76vyPZgcqR49PT3nExMTM/+x0XZ3fePj47/Mzc2RlZVFVVVVRkpKin5/3JWVFWdRUVFeIBCInN7v5NJ55ySV5EUZ8lEArVb728jIiDcvL++ZONqo0MDAwK2ampoyURQTZXlI7ob+PI1aXAR8AegiutVqdXZ2dt6zFs/OzrosFstjLpcr+iR3A+9LkrRzKs2CrGUCV4C3on3NZrPHarX+Xlxc/MARu5nLkiRdPbVuJsa4BDQCxjj6QRH4GvgY+PksOmqF3FG/KVcc9T066s+AH86y5Y8eOXI282XQyJtkRv6d/pvk/rPz/wT41wBibRrpeMs+PAAAAABJRU5ErkJggg==',
      // 左上角图片
      imgClose: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAPYSURBVHja7JVPTFRXFIe/+96gGRHEhQzBFMJKSKSkLTgtGxemSXcktohW2RBmTAjUClIYZ6Cxi+fQDgOCLJgJhqTSBAtLdjaxaSqQWnDSNp2U0I6FFh0SDdV0oMx7pwuZCUXjnyZNuvBsbnLvufe7555zfleJCP+1qReQfwVRSqWmqoFDIE3A+iZXQDbGlMmmNTatP5xPn/0ohOOgLgNtIB8DOlAKvAzsBTKBP4FF4Dvge1DrzwsBaAAuAJ8CxbpuezU/P397QcFLZGVlcf/+fRYXF1lc/G3VNJM/AJ8Dw8CdZ4QoQI4AIWBXaWkpQ0ND5v79+zW73Z5+n9XVVWZnb8rExIQ2MnKZWCz2M/Dhw1d4eiTngXafz2dmZ2ebPp9P6+vrl5qaI2p8fFyi0aheUlJiHj78tpaTs0sHJB6PW4HAJ3og0I2I+AHPkyAeu91uDA4OmrW1tRpAT09vsr29XXM4ciWZTJKXl2ctLCyoHTsy1ZUro+J0OjNSWR8ZGbFcLpeeSCTOAucfBykDpvr7+7c3NjamS+bevXvJ4uIS4vE7tra2tjW/32+7ffu21Ne7rJmZb7VIJKL27Nmjp0ADAwM0NjauAW+IyM2tkAGn8/WG69e/NjVNS20iHA6vd3Z2qrq6OtMwDFswGLROnz6dcffu3WRRUZEVCARwuVzbUv6WZVmVlZXa9PT0RRFp2gq56na7Dw0ODv6jGc6cOWNdu/Zl8saNb/RgMGi1tLSo7u5uaW5u1srLK8yDBw/aursD2ubmcbtPqnA4dFVE3twKuVBeXv7e5OSkabPZ0pGEQuG/WltbicV+0Xbv3m0LBnvWW1qatbNnvclLl4b0c+c+ErfblcoLa2trptPp1CORSEBEWrdCSoBpwzB2ejyedE6Wl5fNsrIyqaiokFAopBwOh/J4PKbf79/mcDiS0WiUnJwcWyoKr9erDMNYBg6ISOxx1dWg6/pAb2+vtZF8DWBqanr96NEalUgkpKCgQJaWljRN04jH43R1dcmpU6dsgBiGobxer3qoGnz2pD5pBfx1dXWaz+czi4qKNECtrKyYY2NjVjQa1fftK7aqq99hdHRUmpqaVEdHhzU/P58xPDycAN4Hws8iK28B/tzc3LJjx96lqqrKOnCggszMzLRmPHjwQM3MzFj19fX63NwcwDJQBUymK+ApEEDtBDkOnFBKvZafv9deWFhIdnYWKysr3Lr1K0tLvydE5CvgJ1AnQZqBi88DSV1aA0qAV4CCDRX+A1gAZoEfN/w/ALqAEyAjzwvZ8mc8KukblgGqD/gCZOyxkBd//P8G8vcAMK383pmr7aEAAAAASUVORK5CYII=',
      dragSlide: false // 拖动滚动条标记

    };
  },
  components: {
    imglist: imglist,
    layer: layer,
    codeedit: codeedit,
    top: top,
    contentmenu: contentmenu,
    SketchRule: SketchRule
  },
  computed: {
    isFolder: function isFolder() {
      return this.activeObj.children;
    },
    isActive: function isActive() {
      return this.active.length !== 0;
    },
    isSelectActive: function isSelectActive() {
      return this.active.length > 1;
    },
    childList: function childList() {
      return this.list.filter(function (ele) {
        if (['tabs'].includes(ele.component.prop)) {
          return false;
        }

        return true;
      });
    },
    activeComponent: function activeComponent() {
      return this.activeObj.component || {};
    },
    activeOption: function activeOption() {
      return this.activeObj.option || {};
    },
    activeObj: function activeObj() {
      var _this = this;

      var result;

      if (this.validatenull(this.active)) {
        return {};
      }

      this.active.forEach(function (ele) {
        var item = _this.findnav(ele, true);

        if (_this.active.length > 1) {
          if (!result) result = [];
          result.push(item.obj);
        } else {
          result = item.obj;
        }
      });
      return result;
    },

    /* 标尺用的 */
    palette: function palette() {
      return {
        bgColor: '#181b24',
        // ruler bg color
        longfgColor: '#BABBBC',
        // ruler longer mark color
        shortfgColor: '#9C9C9C',
        // ruler shorter mark color
        fontColor: '#DEDEDE',
        // ruler font color
        shadowColor: '#525252',
        // ruler shadow color
        lineColor: '#EB5648',
        borderColor: '#B5B5B5',
        cornerActiveColor: '#fff'
      };
    },
    // 画布大小,一定要是computer里面,否则缩放页面会失效
    canvasStyle: function canvasStyle() {
      return {
        width: window.innerWidth - 530 + 'px',
        // 530为左边180+右边350
        height: window.innerHeight - 45 + 'px',
        // 顶部下拉45
        transform: "scale(".concat(this.scale, ")")
      };
    }
  },
  watch: {
    menuFlag: function menuFlag() {
      this.setResize();
    },
    overactive: function overactive(n, o) {
      var _this2 = this;

      [o, n].forEach(function (ele, index) {
        if (!ele) return;

        _this2.setActive(ele, index === 1, 'setOverActive');
      });
    },
    active: function active(n, o) {
      var _this3 = this;

      [o, n].forEach(function (ele, index) {
        ele.forEach(function (item) {
          _this3.setActive(item, index === 1, 'setActive');
        });
      }); //隐藏右键菜单

      this.$refs.contentmenu.hide(); // 初始化选项卡

      this.tabsActive = '0';
    }
  },
  created: function created() {
    this.listen();
    this.iniresize();
  },
  mounted: function mounted() {
    var _this4 = this;

    this.initFun();
    this.$nextTick(function () {
      _this4.initSize();
    });
  },
  methods: {
    codeClose: function codeClose(value) {
      if (this.code.type === 'query') {
        this.config.query = value;
      } else {
        this.activeObj[this.code.type] = value;
        this.$refs.container.handleRefresh();
        console.log(this.activeObj, this, '--this.codethis.code');
      }
    },
    openCode: function openCode(type) {
      this.code.type = type;

      if (type === 'query') {
        this.code.obj = this.config.query;
      } else {
        this.code.obj = this.activeObj[type];
      }

      this.code.box = true;
    },
    initFun: function initFun() {
      var _this5 = this;

      ['setScale', 'setResize'].forEach(function (ele) {
        console.log('init');
        _this5[ele] = _this5.$refs.container[ele];
      });
      ['handleAdd'].forEach(function (ele) {
        _this5[ele] = _this5.$refs.top[ele];
      });
    },
    // 右键菜单
    handleContextMenu: function handleContextMenu(e) {
      var _this6 = this;

      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!item.index) {
        return;
      }

      if (!this.isSelectActive) {
        this.active = [item.index];
      }

      setTimeout(function () {
        _this6.$refs.contentmenu.show(e.clientX, e.clientY);
      }, 0);
    },
    //监听键盘的按键
    listen: function listen() {
      var _this7 = this;

      document.onkeydown = function (e) {
        // 去掉默认滚动条按空格跳到后面行为
        if (e.target.nodeName == 'TEXTAREA' || e.target.nodeName == 'INPUT') {
          return;
        } // 按下空格键


        if (e.keyCode == 32) {
          e.preventDefault();
          _this7.keys.space = true;
        } // 如果是delete按键,那么调用删除组件按钮


        if (e.keyCode === 46) {
          _this7.deleteMethod();
        }

        _this7.keys.ctrl = e.keyCode === 17;
      };

      document.onkeyup = function () {
        _this7.keys.ctrl = false;
      };
    },
    deleteMethod: function deleteMethod() {
      var _this8 = this;

      this.active.forEach(function (index) {
        var params = _this8.findnav(index);

        delete params.parent.splice(params.count, 1);
      });
      this.handleInitActive();
    },
    setActive: function setActive(val, result, fun) {
      var obj = this.$refs.container.handleGetObj(val);
      if (!this.validatenull(obj)) obj[0][fun](result);
    },
    //批量成组
    handleFloder: function handleFloder() {
      var _this9 = this;

      var floder = {
        "title": "文件夹",
        "name": "文件夹",
        "index": uuid(),
        "children": []
      };
      this.active.forEach(function (index) {
        var params = _this9.findnav(index);

        floder.children.push(params.obj);
        delete params.parent.splice(params.count, 1);
      });
      this.nav.push(floder);
      this.handleInitActive();
    },
    //批量删除
    handleDeleteSelect: function handleDeleteSelect() {
      var _this10 = this;

      this.$confirm("\u662F\u5426\u6279\u91CF\u5220\u9664\u6240\u9009\u56FE\u5C42?", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this10.deleteMethod();
      });
    },
    vaildProp: function vaildProp(name, list) {
      if (list) {
        return list.includes(this.activeComponent.prop);
      }

      return this.dicOption[name].includes(this.activeComponent.prop);
    },
    handleRefresh: function handleRefresh(tip) {
      this.$refs.container.handleRefresh(tip);
    },
    formatTooltip: function formatTooltip(val) {
      return parseInt(val);
    },
    //打开图库
    handleOpenImg: function handleOpenImg(item, type) {
      this.$refs.imglist.openImg(item, type);
    },
    // 文本框的值设置
    handleTextSet: function handleTextSet(text) {
      console.log(this.$refs, text, '---handleTextSet');
      this.activeObj.data.value = text;
    },
    //图库框回调赋值
    handleSetimg: function handleSetimg(val, type) {
      if (type === 'activeObj.data') {
        this.activeObj.data = val;
      }

      if (type === 'activeObj.data.value') {
        this.activeObj.data.value = val;
      } else if (type === 'activeOption.backgroundImage') {
        this.activeOption.backgroundImage = val;
      } else if (type === 'activeOption.backgroundBorder') {
        this.activeOption.backgroundBorder = val;
      } else if (type === 'activeOption.empBackgroundBorder') {
        this.activeOption.empBackgroundBorder = val;
      } else if (type === 'config.backgroundImage') {
        this.config.backgroundImage = val;
      } else if (type === 'activeOption.symbol') {
        this.activeOption.symbol = val;
      }
    },

    /* **************************标尺方法开始******************************* */
    // 滚轮触发
    handleScroll: function handleScroll() {
      var screensRect = this.$refs.screensRef.getBoundingClientRect();
      var canvasRect = this.$refs.canvas.getBoundingClientRect(); // 标尺开始的刻度

      var startX = (screensRect.left + this.thick - canvasRect.left) / this.scale;
      var startY = (screensRect.top + this.thick - canvasRect.top) / this.scale;
      this.startX = startX >> 0;
      this.startY = startY >> 0;
    },
    // 控制缩放值
    handleWheel: function handleWheel(e) {
      var _this11 = this;

      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        var nextScale = parseFloat(Math.max(0.2, this.scale - e.deltaY / 500).toFixed(2));
        this.scale = nextScale;
      }

      this.$nextTick(function () {
        _this11.handleScroll();
      });
    },
    // 初始化标尺数值
    initSize: function initSize() {
      var domW = this.$refs.wrapper;
      var width = window.innerWidth - 530;
      var height = window.innerHeight - 45;
      domW.style.width = width + 'px';
      domW.style.height = height + 'px';
      this.width = width - this.thick;
      this.height = height - this.thick; // 画布阴影部分

      this.shadow = {
        x: 0,
        y: 0,
        width: width,
        height: height
      }; // 滚动居中

      var dom = this.$refs.containerRef.getBoundingClientRect();
      this.$refs.screensRef.scrollLeft = dom.width / 2 - this.thick;
      this.$refs.screensRef.scrollTop = dom.height / 2 - this.thick;
    },
    // resize
    iniresize: function iniresize() {
      var _this12 = this;

      window.addEventListener('resize', function () {
        var width = _this12.width;
        var height = _this12.height;

        _this12.initSize();

        var rate = Math.min(_this12.width / width, _this12.height / height);
        _this12.scale = rate > 1 ? rate * 0.5 : rate;
        _this12.rendIndex++;
      });
    },
    // 图片点击事件
    imgClick: function imgClick() {
      this.isShowReferLine = !this.isShowReferLine;
    },
    // 鼠标按下事件
    dragMousedown: function dragMousedown(e) {
      // 如果按下了空格键,且按下鼠标左键,那么鼠标变抓手,开启滚动条随鼠标拖动的操作
      if (this.keys.space) {
        this.dragSlide = true;
        window.stardragEvent = e;
        window.startSlideX = this.$refs.screensRef.scrollLeft;
        window.startSlideY = this.$refs.screensRef.scrollTop;
      }
    },
    //鼠标抬起操作
    dragMouseup: function dragMouseup() {
      this.dragSlide = false;
    },
    // 鼠标移动骚操作
    dragMousemove: function dragMousemove(e) {
      if (this.dragSlide) {
        var x = e.clientX - window.stardragEvent.clientX;
        var y = e.clientY - window.stardragEvent.clientY;
        this.$refs.screensRef.scrollLeft = window.startSlideX - x;
        this.$refs.screensRef.scrollTop = window.startSlideY - y;
      }
    }
  }
};